module.exports = __webpack_public_path__ + "static/media/sign.b5fa5c06.svg";